module.exports = __webpack_public_path__ + "static/media/option-4.84b25ef5.ogg";